export const paths = {
  wallet: "/wallet",
  myOffers: "/wallet/myoffers",
  nearMe: "/nearme",
  profile: "/profile",
} as const;
